import { useContext, useEffect, useState } from "react";
import DataContext from "../../context/DataContext";
import styles from "./styles/TermsDisclaimer.module.css";
import NavButton from "../../components/ui/navbutton/NavButton";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../utils/utils";
import { useLocation, useNavigate } from "react-router-dom";
import { generateHTML } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { EMPTY_DOC } from "../customization/Customization";
import Button from "../../components/ui/button/Button";

const TermsDisclaimer = ({ header, contentName }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [notReadyView, setNotReadyView] = useState(true);

    useEffect(() => {
        if (!location.state?.fromApp) {
            navigate(homePath, { replace: true });
        }
    }, [location, navigate]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setNotReadyView(!location.state?.fromApp);
        }, 50);

        // Cleanup function
        return () => {
            clearTimeout(timer);
        };
    }, []);

    const {
        paymentHeaderFooterHeight, // {Float} - The calculated height of the header and footer
        homePath,
        localizations,
    } = useContext(DataContext);
    const { i18n, t } = useTranslation();
    // const sectionKey = `${content}.sections`;
    // const titleKey = `${content}.title`;

    // const sections = t(sectionKey, {
    //     returnObjects: true,
    // });

    const currentLanguage = i18n.language; // "en"

    const currentLocalization =
        localizations.find((language) =>
            language.culture
                .toLowerCase()
                .startsWith(currentLanguage.toLowerCase()),
        ) ?? localizations[0]; // fallback

    const dynamicContent = currentLocalization?.dynamicContent
        ? JSON.parse(currentLocalization?.dynamicContent)
        : {};

    const rawContent = dynamicContent?.[contentName]
        ? dynamicContent?.[contentName]
        : EMPTY_DOC;

    // const sectionsArray = Array.isArray(sections) ? sections : [];

    const contentHTML = generateHTML(rawContent, [
        StarterKit.configure({
            heading: { levels: [1, 2, 3] },
        }),
    ]);

    return (
        <article
            className={`  main-page-container flex-container ${styles.main_page_wrapper}`}
            style={{
                // Set the min height of the main page container to the height of the window
                // minus the calculated height of the header and footer
                minHeight: `calc(100vh - ${paymentHeaderFooterHeight}px)`,
            }}
        >
            <section
                className={`${styles.main_info_container} transition-container ${
                    notReadyView ? "transition-hidden" : "transition-visible"
                } v-flex-container`}
            >
                {console.log("notReadyView: ", notReadyView)}
                <h2 className={`${styles.main_info_container_header}`}>
                    {t(header)}
                </h2>
                <div className={`${styles.info_container}`}>
                    <div dangerouslySetInnerHTML={{ __html: contentHTML }} />
                    {/* <div>
                        {sectionsArray.map((item, idx) => (
                            <div
                                className={`${styles.content_point} `}
                                key={idx}
                            >
                                <h3>
                                    <span>{`${idx + 1}- `}</span>
                                    {capitalizeFirstLetter(item.title)}
                                </h3>
                                <p>{item.content}</p>
                            </div>
                        ))}
                    </div> */}
                </div>
                <div className={`${styles.button_container} flex-container`}>
                    <Button
                        body={t("go back")}
                        type={"button"}
                        onClickFuction={() => navigate(-1)}

                        //
                    />
                </div>
            </section>
        </article>
    );
};

export default TermsDisclaimer;
